export default __webpack_public_path__ + "static/media/vect-eclipse-secondary.1b9639b2.svg";